import React from 'react';
import useTeams from '../../utils/useTeam';

const prefix =
  process.env.NODE_ENV === 'production'
    ? 'https://img.paperform.co/fetch/w_601,f_auto/'
    : '';

const getLayoutClass = (layout) => {
  if (layout === '432') return 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4';
  if (layout === '421') return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4';
  if (layout === '321') return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
  if (layout === '221') return 'grid-cols-1 sm:grid-cols-2';
  if (layout === '211') return 'grid-cols-1 lg:grid-cols-2';
  if (layout === '111') return 'grid-cols-1';
};

function InlineTeam({ teams = ['All'], layout = '432' }) {
  const teamList = useTeams(teams);
  const layoutClass = getLayoutClass(layout);

  return (
    <div className={`grid gap-y-6 gap-2 mb-6 ${layoutClass}`}>
      {teams.map((team) =>
        teamList[team]?.map(
          ({ node: { name, job_title, image, alt_image } }, i) => (
            <div key={i}>
              <div
                alt={name}
                style={{
                  width: '100%',
                  margin: 0,
                  paddingBottom: '140%',
                  backgroundImage: `url(${prefix}${image})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  position: 'relative',
                }}
              >
                {alt_image ? (
                  <div
                    className="opacity-0 hover:opacity-100 transition-all transition-500"
                    style={{
                      width: '100%',
                      height: '100%',
                      zIndex: 1,
                      position: 'absolute',
                      backgroundImage: `url(${prefix}${alt_image})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}
                  />
                ) : null}
              </div>
              <div className="py-2">
                <div className="text-sm">{name}</div>
                <div className="text-xs opacity-75">{job_title}</div>
              </div>
            </div>
          ),
        ),
      )}
    </div>
  );
}
export default InlineTeam;
